import { toast } from "react-toastify";


export const successMessage = (message:string) =>{
    toast.success(message)
 }

 export const errorMessage = (message:string) =>{
   toast.error(message)
 }

 export const objectToFormData = (obj, formData = new FormData(), parentKey = "") => {
  if (obj && typeof obj === "object" && !(obj instanceof File)) {
    Object.keys(obj).forEach((key) => {
      const fullKey = parentKey ? `${parentKey}[${key}]` : key;
      const value = obj[key];

      if (Array.isArray(value)) {
        // Handle arrays (e.g., multiple files or simple arrays)
        value.forEach((item, index) => {
          if (item instanceof File) {
            // If it's a file, append normally
            formData.append(`${fullKey}[${index}]`, item);
          } else {
            // Recursively handle nested arrays/objects
            objectToFormData(item, formData, `${fullKey}[${index}]`);
          }
        });
      } else if (value instanceof File) {
        // If it's a file, append it directly
        formData.append(fullKey, value);
      } else if (typeof value === "object" && value !== null) {
        // Recursively handle nested objects
        objectToFormData(value, formData, fullKey);
      } else {
        // Append normal key-value pairs
        formData.append(fullKey, value);
      }
    });
  }

  return formData;
};
